<div class="p-3 mb-3 border border-dark">
  <form [formGroup]="paymentForm" id="payment-form">
    <div class="form-check">
      <input [value]="false"
             id="payWithCreditCard"
             class="form-check-input"
             type="radio"
             formControlName="paymentControl">
      <label for="payWithCreditCard"
             class="form-check-label">
        Pay with Credit Card/PCard
      </label>
    </div>
    <div class="form-check">
      <input [value]="true"
             id="payWIthPurchaseOrder"
             class="form-check-input"
             type="radio"
             formControlName="paymentControl">
      <label for="payWIthPurchaseOrder"
             class="form-check-label">
        Pay with UShop Purchase Order
      </label>
    </div>
  </form>
</div>
